module.exports = __webpack_public_path__ + "img/home-student.fafa420c.png";